import React from "react";
import PropTypes from "prop-types";
import PasswordChangeFormContent from "../components/PasswordChangeFormContent";

import { connect } from "react-redux";
import { savePassword } from "../../../redux/actions/auth";
import { FormMenu } from "../../../components/Buttons";

const mapStateToProps = null;
const mapDispatchToProps = (dispatch) => ({
  changePassword: (...args) => dispatch(savePassword(...args)),
});

const PasswordChangeForm = (props) => {
  const { className, changePassword, onClose } = props;
  const formRef = React.useRef(null);

  const onSave = () => {
    const model = formRef.current.getModel();
    if (!model) return;
    console.log(">> saving new password", model);
    changePassword(model, onClose);
  };
  const onCancel = () => {
    onClose && onClose();
  };

  return (
    <div className={`${className}`}>
      <PasswordChangeFormContent ref={formRef} />
      <FormMenu
        className="margin-lg-top w3-border-top pad-big w3-light-grey"
        style={{
          marginLeft: "-1em",
          marginRight: "-1em",
          marginBottom: "-1em",
        }}
        onSave={onSave}
        onCancel={onCancel}
        saveBtnName="changePasswordBtn"
      />
    </div>
  );
};

PasswordChangeForm.propTypes = {
  className: PropTypes.string,
  changePassword: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};
PasswordChangeForm.defaultProps = {
  className: "",
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PasswordChangeForm);
